
import React from 'react';
import { 
  Music, Clock, Award, MapPin, ExternalLink, Globe, UserPlus, Home, 
  Navigation, Car, Book, Users, Layers, Settings, GraduationCap, Medal, 
  Bus, Landmark, Map, Route
} from 'lucide-react';

export interface Feature {
  title: string;
  description: string;
  icon: string;
}

interface LocationFeaturesProps {
  features: Feature[];
}

const LocationFeatures = ({ features }: LocationFeaturesProps) => {
  const getIcon = (icon: string) => {
    switch (icon) {
      case 'music':
        return <Music className="h-8 w-8" />;
      case 'clock':
        return <Clock className="h-8 w-8" />;
      case 'award':
        return <Award className="h-8 w-8" />;
      case 'map-pin':
        return <MapPin className="h-8 w-8" />;
      case 'location':
        return <MapPin className="h-8 w-8" />;
      case 'link':
        return <ExternalLink className="h-8 w-8" />;
      case 'globe':
        return <Globe className="h-8 w-8" />;
      case 'user':
        return <UserPlus className="h-8 w-8" />;
      case 'users':
        return <Users className="h-8 w-8" />;
      case 'home':
        return <Home className="h-8 w-8" />;
      case 'navigation':
        return <Navigation className="h-8 w-8" />;
      case 'car':
        return <Car className="h-8 w-8" />;
      case 'book':
        return <Book className="h-8 w-8" />;
      case 'layers':
        return <Layers className="h-8 w-8" />;
      case 'settings':
        return <Settings className="h-8 w-8" />;
      case 'graduation-cap':
        return <GraduationCap className="h-8 w-8" />;
      case 'medal':
        return <Medal className="h-8 w-8" />;
      case 'bus':
        return <Bus className="h-8 w-8" />;
      case 'landmark':
        return <Landmark className="h-8 w-8" />;
      case 'map':
        return <Map className="h-8 w-8" />;
      case 'route':
        return <Route className="h-8 w-8" />;
      default:
        return <Music className="h-8 w-8" />;
    }
  };

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-gray-50 p-8 rounded-lg shadow-sm text-center transition-transform hover:translate-y-[-5px]">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-piano-gold/10 text-piano-gold mb-6">
                {getIcon(feature.icon)}
              </div>
              <h3 className="text-xl font-serif font-semibold mb-4">{feature.title}</h3>
              <p className="text-gray-600">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LocationFeatures;
